import { carePlanIdSchema } from "@repo/api/schemas";
import { useCarePlan } from "@repo/data-store";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Curation } from "@/app/surfaces/curation";

export const Route = createFileRoute("/patients/$patientId/care-plans/$carePlanId/edit")({
  component: RouteComponent,
});

/**
 * The treatment plan editor — a full-inset route rather than a panel on the
 * plan detail, because the canvas needs the whole width. Edits the order sets of the selected active care plan.
 */
function RouteComponent() {
  const { patientId, carePlanId } = Route.useParams();
  const navigate = useNavigate();
  const carePlan = useCarePlan(carePlanIdSchema.parse(carePlanId));

  const close = () =>
    navigate({ to: "/patients/$patientId/care-plans/$carePlanId", params: { patientId, carePlanId } });

  if (!carePlan) return <div className="p-6 text-muted-foreground">Treatment plan not found.</div>;
  if (carePlan.status !== "active") {
    return <div className="p-6 text-muted-foreground">This care plan is not active.</div>;
  }

  return (
    <Curation.Provider carePlanId={carePlan.carePlanId}>
      <Curation.Canvas onClose={close} />
    </Curation.Provider>
  );
}
